<template>
  <div>
    <v-toolbar color="grey lighten-2" absolute flat height="24em" tabs>
      <template slot="extension">
        <v-tabs v-model="currentTab" centered flat icons-and-text class="pb-4" color="grey lighten-2">
          <v-tab href="#tab-1" to="/reportes/people" v-if="$store.state.permissions.canViewReportes && $store.getters.isSafRole">
            <span>Personas</span>
            <v-icon>fa-users</v-icon>
          </v-tab>
          <v-tab href="#tab-2" to="/reportes/presentaciones" v-if="$store.state.permissions.canViewReportes &&
          $store.getters.isSafRole && $store.state.permissions.canViewPresentaciones">
            <span>Presentaciones</span>
            <v-icon>mdi-file-document-outline</v-icon>
          </v-tab>
          <v-tab href="#tab-3" to="/reportes/consultas" v-if="$store.state.permissions.canViewReportes &&
          $store.getters.isSafRole && $store.state.permissions.canViewConsultas">
            <span>Consultas</span>
            <v-icon>mdi-comment-text-outline</v-icon>
          </v-tab>
          <v-tab href="#tab-4" to="/reportes/expedientes" v-if="$store.state.permissions.canViewReportes &&
          $store.getters.isSafRole && $store.state.permissions.canViewExpedientes">
            <span>Expedientes</span>
            <v-icon>inbox</v-icon>
          </v-tab>
          <v-tab href="#tab-5" to="/reportes/contratos/jugadores" v-if="$store.state.permissions.canViewReportes &&
          $store.getters.isSafRole && $store.state.permissions.canViewContratos">
            <span>Contratos<br/>Jugadores</span>
            <v-icon>gavel</v-icon>
          </v-tab>
          <v-tab href="#tab-6" to="/reportes/contratos/cuerpo-tecnico" v-if="$store.state.permissions.canViewReportes &&
          $store.getters.isSafRole && $store.state.permissions.canViewCuerpoTecnico">
            <span>Contratos<br/>Cuerpo Técnico</span>
            <v-icon>gavel</v-icon>
          </v-tab>
          <v-tab href="#tab-7" to="/reportes/condiciones/jugadores" v-if="$store.state.permissions.canViewReportes &&
          $store.getters.isSafRole && $store.state.permissions.canViewConditions">
            <span>Cond. Salariales<br/>Jugadores</span>
            <v-icon>request_quote</v-icon>
          </v-tab>
          <v-tab href="#tab-8" to="/reportes/condiciones/cuerpo-tecnico" v-if="$store.state.permissions.canViewReportes &&
          $store.getters.isSafRole && $store.state.permissions.canViewConditions && $store.state.permissions.canViewCuerpoTecnico">
            <span>Cond. Salariales<br/>Cuerpo Técnico</span>
            <v-icon>request_quote</v-icon>
          </v-tab>
          <v-tab href="#tab-9" to="/reportes/pagos/jugadores" v-if="$store.state.permissions.canViewReportes &&
          $store.getters.isSafRole && $store.state.permissions.canViewConditions">
            <span>Pagos<br/>Jugadores</span>
            <v-icon>local_atm</v-icon>
          </v-tab>
          <v-tab href="#tab-10" to="/reportes/pagos/cuerpo-tecnico" v-if="$store.state.permissions.canViewReportes &&
          $store.getters.isSafRole && $store.state.permissions.canViewConditions && $store.state.permissions.canViewCuerpoTecnico">
            <span>Pagos<br/>Cuerpo Técnico</span>
            <v-icon>local_atm</v-icon>
          </v-tab>
          <v-tab href="#tab-11" to="/reportes/transferencias" v-if="$store.state.permissions.canViewTransferencias">
          <span>Transferencias<br/>entre Clubes</span>
            <v-icon>transfer_within_a_station</v-icon>
          </v-tab>
          <v-tab href="#tab-12" to="/reportes/contratos/vencimientos/jugadores" v-if="$store.state.permissions.canViewReportes &&
          $store.getters.isSafRole && $store.state.permissions.canViewContratos">
            <span>Vencimientos Contratos<br/>Jugadores</span>
            <v-icon>gavel</v-icon>
          </v-tab>
          <v-tab href="#tab-13" to="/reportes/contratos/vencimientos/cuerpo-tecnico" v-if="$store.state.permissions.canViewReportes &&
          $store.getters.isSafRole && $store.state.permissions.canViewCuerpoTecnico">
            <span>Vencimientos Contratos<br/>Cuerpo Técnico</span>
            <v-icon>gavel</v-icon>
          </v-tab>
          <v-tab href="#tab-14" to="/reportes/adendas/jugadores" v-if="$store.state.permissions.canViewReportes && $store.getters.isSafRole && $store.state.permissions.canViewContratos">
            <span>Adendas<br/>Jugadores</span>
            <v-icon>post_add</v-icon>
          </v-tab>
          <v-tab href="#tab-15" to="/reportes/adendas/cuerpo-tecnico" v-if="$store.state.permissions.canViewReportes &&
          $store.getters.isSafRole && $store.state.permissions.canViewCuerpoTecnico">
            <span>Adendas<br/>Cuerpo Técnico</span>
            <v-icon>post_add</v-icon>
          </v-tab>
          <v-tab href="#tab-5" to="/reportes/informes/partidos" v-if="$store.state.permissions.canViewReportes &&
          $store.getters.isSafRole && $store.state.permissions.canViewReportFaults">
            <span>Informes<br/>Partidos</span>
            <v-icon>fa-futbol</v-icon>
          </v-tab>
          <v-tab href="#tab-16" to="/reportes/contratos/detalle/jugadores" v-if="$store.state.permissions.canViewReportes &&
          $store.getters.isSafRole && $store.state.permissions.canViewContratos">
            <span>Contratos VERIFICADOS Y<br/>PENDIENTES Jugadores</span>
            <v-icon>gavel</v-icon>
          </v-tab>
          <v-tab href="#tab-17" to="/reportes/contratos/detalle/cuerpo-tecnico" v-if="$store.state.permissions.canViewReportes &&
          $store.getters.isSafRole && $store.state.permissions.canViewCuerpoTecnico">
            <span>Contratos VERIFICADOS Y<br/>PENDIENTES Cuerpo Técnico</span>
            <v-icon>gavel</v-icon>
          </v-tab>
        </v-tabs>
      </template>
    </v-toolbar>
    <div class="top-spacing">
      <router-view></router-view>
    </div>
  </div>
</template>

<script>

export default {

  data () {
    return {
      currentTab: null,
      tabs: [
        { id: 1, componentName: 'People' },
        { id: 2, componentName: 'Presentation' },
        { id: 3, componentName: 'Consulta' },
        { id: 4, componentName: 'Expediente' },
        { id: 5, componentName: 'ContratoJugadores' },
        { id: 6, componentName: 'ContratoCuerpoTecnico' },
        { id: 7, componentName: 'CondicionJugadores' },
        { id: 8, componentName: 'CondicionCuerpoTecnico' },
        { id: 9, componentName: 'PagosJugadores' },
        { id: 10, componentName: 'PagosCuerpoTecnico' },
        { id: 11, componentName: 'Transferencias' },
        { id: 12, componentName: 'VencimientoContratoCuerpoTecnico' },
        { id: 13, componentName: 'VencimientoContratoJugadores' },
        { id: 14, componentName: 'AdendasJugadores' },
        { id: 15, componentName: 'AdendasCuerpoTecnico' },
        { id: 16, componentName: 'InformesPartidos' }
      ]
    }
  }
}
</script>

<style scoped>
.top-spacing {
  margin-top: 5em;
}
</style>
